import { get } from 'lodash';
import { createAction } from 'redux-actions';
import { CALL_API } from '../constants';

const toSettings = ({ settings = {} }) => {
  const { atDoctor, atHome, atPharmacy } = settings;
  return {
    atDoctor,
    atHome,
    atPharmacy,
  };
};

const NotificationSettingsService = {
  getByUserId: createAction(CALL_API, userId => ({
    method: 'GET',
    path: `/usernotificationsettings/${userId}`,
    handleResponse: response => toSettings(get(response, '0', {})),
    handleError: () =>
      Promise.reject(
        'We were unable to load your notification settings. Please refresh the page to try again.',
      ),
  })),

  create: createAction(CALL_API, notificationSettings => ({
    body: notificationSettings,
    method: 'POST',
    path: '/usernotificationsettings',
    handleError: () =>
      Promise.reject('Something went wrong. Please try again.'),
  })),
};

export default NotificationSettingsService;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/notificationSettings/NotificationSettingsService.js